export function stripHtml (value) {
    return (value || '').replace(/<[^>]*>/g, '')
}

export function useStripHtml () {
    return {
        stripHtml,
    }
}